import { render, staticRenderFns } from "./HookInput.vue?vue&type=template&id=4d38497e&scoped=true&"
import script from "./HookInput.vue?vue&type=script&lang=js&"
export * from "./HookInput.vue?vue&type=script&lang=js&"
import style0 from "./HookInput.vue?vue&type=style&index=0&id=4d38497e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38497e",
  null
  
)

export default component.exports